export function lerPares(hash: string): Record<string, string> {
  const raw = hash.replace(/^#/, '');
  const out: Record<string, string> = {};
  if (!raw) return out;
  for (const parte of raw.split('&')) {
    const i = parte.indexOf('=');
    if (i < 1) continue;
    const chave = decodeURIComponent(parte.slice(0, i));
    const valor = decodeURIComponent(parte.slice(i + 1).replace(/\+/g, '%20'));
    if (chave) out[chave] = valor;
  }
  return out;
}

export function lerFragmento(): Record<string, string> {
  const pares = lerPares(window.location.hash);
  const limpo = window.location.pathname + window.location.search;
  window.history.replaceState(null, '', limpo);
  return pares;
}
